import { render, staticRenderFns } from "./PopupSubTable.vue?vue&type=template&id=365fa5d4&scoped=true"
import script from "./PopupSubTable.vue?vue&type=script&lang=js"
export * from "./PopupSubTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365fa5d4",
  null
  
)

export default component.exports